export {TimeDisplay} from './time-display';



// WEBPACK FOOTER //
// ./components/time-display/index.js


// WEBPACK FOOTER //
// ui/components/time-display/index.js